


















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import BaseComponent from '@/components/base-component.vue';
import IClient from '@/interfaces/client';
import { getUserClients, setSelectedClient, setSelectedBusinessUnit } from '@/services/users';
import {
  setSelectedClientToLocal,
  getSelectedClientFromLocal,
  setSelectedBusinessUnitToLocal,
  getSelectedBusinessUnitFromLocal,
  getLocalBusinessUnit,
  getLocalUser,
  getLocalClient,
} from '@/services/session-data';
import * as changeClientDialog$ from '@/subjects/change-client-dialog';

@Component
export default class UiChangeCurrentClient extends BaseComponent {
  public user: any = {};
  public clientList: IClient[] = [];

  @Prop(Boolean)
  public changeClient: boolean;

  @Prop()
  public unidade: any;

  @Watch('unidade')
  public onChangeUnidade(val): void {
    this.onClientClick(val);
  }

  @Watch('show')
  public onChangeShow(val): void {
    this.changeClient = val;
  }

  public selectedClient: any = {
    nome: '',
    imagem: '',
  };

  public selectedBusinessUnit: any = {
    razaoSocial: '',
    imagem: '',
  };

  public created(): void {
    this.getClients();
    changeClientDialog$.get().subscribe((status) => {
      if (status === changeClientDialog$.STATUS_SHOW) {
        this.openModalClient();
      } else {
        this.closeModalClient();
      }
    });
  }

  public onClientClick(clientUnit: any) {
    const payload = {
      unidadeCliente: clientUnit.nome,
      idUnidadeCliente: clientUnit.id,
    };

    this.loader.start();

    setSelectedClient(payload).subscribe(
      (data) => {
        this.closeModalClient();
        setSelectedClientToLocal(clientUnit);
        this.loader.stop();
        this.$emit('changeClient', clientUnit);
        window.location.reload();
      },
      () => {
        this.toast.show('Ocorreu um erro ao selecionar o cliente', 'error');
      },
    );
  }

  private getCurrentUser(): void {
    getLocalUser().subscribe((data) => {
      if (!!data) {
        this.user = data;
      }
    });
  }

  public closeModalClient(): void {
    // Tratamento para usuários MultiEmpresa e MultiUnidades
    // Ao fechar a PopUp de Unidades, verificar:
    // Se tiver uma Unidade somente e não tiver ainda selecionada, seleciona-a
    // Se tiver uma única empresa e ainda não tiver selecionado, seleciona-a
    this.getCurrentUser();
    this.getCurrentClient();
    this.getCurrentBusinessUnit();
    if (this.user.listaUnidades.length > 1) {
        // Se a empresa ainda não foi selecionada e só tem uma, força a seleção da mesma
        if (this.user.listaEmpresas.length === 1 && this.selectedBusinessUnit.razaoSocial === ""){
          setSelectedBusinessUnit(this.user.listaEmpresas[0].id);
          setSelectedBusinessUnitToLocal(this.user.listaEmpresas[0]);
          window.location.reload();
        // Se tiver uma única unidade e ela já foi selecionada, sai fora..
        } else if (this.user.listaUnidades.length === 1 && this.selectedClient.nome !== "") {
          this.changeClient = false;
        }
    } else {
      // Se ele tem uma única Unidade e ainda não foi selecionada, seleciona-a
      // Porém, nunca seleciona Unidade nem para Medico nem para EMEDE
      if (this.user.listaUnidades.length === 1 && this.selectedClient.nome === ""
            && this.user.tipoLogin !== "MEDICO" && this.user.tipoAcesso !== "EMEDE") {
        setSelectedClient(this.user.listaUnidades[0]);
        setSelectedClientToLocal(this.user.listaUnidades[0]);
        window.location.reload();        
      }
      // Se ele tem uma única empresa e ainda não foi selecionada, seleciona-a
      if (this.user.listaEmpresas.length === 1 && this.selectedBusinessUnit.razaoSocial === "") {
        setSelectedBusinessUnit(this.user.listaEmpresas[0].id);
        setSelectedBusinessUnitToLocal(this.user.listaEmpresas[0]);
        window.location.reload();        
      }
    }
  }

  private getCurrentClient(): void {
    getSelectedClientFromLocal().subscribe((data) => {
      if (!!data) {
        this.selectedClient = data;
      }
    });
  }

  private getCurrentBusinessUnit(): void {
    getSelectedBusinessUnitFromLocal().subscribe((data) => {
      if (!!data) {
        this.selectedBusinessUnit = data;
      }
    });
  }

  public openModalClient() {
    this.changeClient = true;
  }

  private getClients(): void {
    getUserClients().subscribe((data) => {
      this.clientList = data;
    });
  }
}
